import { Button, Modal } from 'shared/components/ui';
import React, { useEffect, useState } from 'react';
import { Alert, Box, Stack, Typography } from '@mui/material';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import WarningAmber from '@mui/icons-material/WarningAmber';
const ConfirmModal = ({ show, title, message, onConfirm, onCancel, centered = true, tone = 'danger' }) => {
  const [pending, setPending] = useState(false);
  const [error, setError] = useState('');
  const color = tone === 'danger' ? 'error' : 'warning';
  const Icon = tone === 'danger' ? DeleteOutline : WarningAmber;
  useEffect(() => { if (show) { setPending(false); setError(''); } }, [show]);
  const confirm = async () => {
    if (pending) return;
    setPending(true);
    setError('');
    try { await onConfirm(); }
    catch { setError('No se pudo completar la acción. Intentá nuevamente.'); }
    finally { setPending(false); }
  };
  return (
    <Modal show={show} onHide={pending ? undefined : onCancel} centered={centered} backdrop={pending ? 'static' : true} keyboard={!pending} size="sm">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Stack direction="row" gap={2} alignItems="flex-start">
          <Box sx={{ display: 'grid', placeItems: 'center', p: 1, borderRadius: 2, bgcolor: color + '.soft', color: color + '.main' }}><Icon /></Box>
          <Typography variant="body2" sx={{ pt: 0.5 }}>{message}</Typography>
        </Stack>
        {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel} disabled={pending} autoFocus>
          Cancelar
        </Button>
        <Button variant={tone} onClick={confirm} loading={pending}>
          {pending ? 'Procesando…' : 'Confirmar'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
